import { AdGroupDto } from "../../../codegen/Swagger";

export const sortItemsByName = (
    items: (AdGroupDto | undefined)[] | undefined
) => {
    return items?.sort((a, b) => {
        if (a !== undefined && b !== undefined) {
            if (a.name! < b.name!) return -1;
            return a.name! > b.name! ? 1 : 0;
        }
        return 0;
    });
};
